import React from 'react'
import { Link } from 'react-router-dom'

export default function NotFoundPage() {
  return (
    <div className="relative mx-auto flex min-h-[80vh] max-w-5xl flex-col items-center justify-center gap-8 px-4 py-12 text-center">
      <div aria-hidden className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_top,_rgba(16,185,129,0.2),_transparent_60%)]" />
      <div aria-hidden className="absolute inset-0 -z-20 bg-[radial-gradient(circle_at_30%_20%,rgba(236,72,153,0.14),transparent_55%),radial-gradient(circle_at_80%_10%,rgba(168,85,247,0.18),transparent_58%)] dark:bg-[radial-gradient(circle_at_20%_18%,rgba(236,72,153,0.12),transparent_55%),radial-gradient(circle_at_85%_18%,rgba(168,85,247,0.15),transparent_50%)]" />

      <div className="mx-auto flex max-w-3xl flex-col items-center gap-6 rounded-3xl border border-emerald-100/70 bg-white/95 p-10 shadow-2xl shadow-emerald-500/10 backdrop-blur-sm dark:border-emerald-900/60 dark:bg-zinc-950/90">
        <span className="inline-flex h-16 w-16 items-center justify-center rounded-full border border-emerald-200/70 bg-emerald-50/70 text-2xl font-semibold text-emerald-600 dark:border-emerald-900/60 dark:bg-emerald-900/30 dark:text-emerald-200">
          404
        </span>
        <div className="space-y-3">
          <h1 className="text-3xl font-bold tracking-tight text-zinc-900 dark:text-white sm:text-4xl">
            Page introuvable
          </h1>
          <p className="text-base text-zinc-600 dark:text-zinc-300">
            Pas de panique, vous n’êtes pas perdu·e. Cette URL ne correspond à aucune page Totemium.
            Rejoignez l’espace contenus pour retrouver vos médias, ou revenez au tableau de bord.
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/contents"
            className="inline-flex items-center gap-2 rounded-full border border-emerald-200/70 bg-emerald-500 px-5 py-2 text-sm font-semibold text-white shadow-lg shadow-emerald-500/30 transition hover:bg-emerald-600 dark:border-emerald-900/60"
          >
            Ouvrir la bibliothèque
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-full border border-zinc-200/70 px-5 py-2 text-sm font-semibold text-zinc-600 transition hover:bg-zinc-100 dark:border-zinc-700 dark:text-zinc-200 dark:hover:bg-zinc-800"
          >
            Retour au tableau de bord
          </Link>
        </div>
      </div>

      <p className="text-xs uppercase tracking-[0.45em] text-zinc-500 dark:text-zinc-400">
        Totemium • L’IA au service de votre équipe
      </p>
    </div>
  )
}
